import { NewspaperIcon } from 'lucide-react';
import { createElement } from 'react';

import { defineModule } from '@/shared/registry/types';

import { PostCommentSearchResult } from './components/PostCommentSearchResult';
import { LazyGroupFeedTab, LazyPostPanel } from './lazy';
import { registerFeedRealtime } from './lib/realtime';
import { useFeedCounters } from './queries';

/** Sidebar counter: posts by others since the reader last opened the feed (live through `feed.post-created`). */
function useNewPostsCounter(): number | undefined {
  return useFeedCounters().data?.newPosts;
}

/**
 * `feed` — the activity stream on the home page (docs/modules/feed.md): posts, polls, gratitudes, important
 * announcements, comments and reactions, system entries of other modules; the `post:<id>` side panel and the "Feed"
 * tab of group pages.
 */
export const module = defineModule({
  id: 'feed',
  routes: [{ index: true, lazy: async () => ({ Component: (await import('./pages/FeedPage')).default }) }],
  nav: [
    {
      id: 'feed',
      labelKey: 'feed:nav.title',
      icon: NewspaperIcon,
      to: '/',
      end: true,
      order: 10,
      section: 'main',
      useCounter: useNewPostsCounter,
    },
  ],
  sidePanels: [{ type: 'post', component: LazyPostPanel, size: 'lg', titleKey: 'feed:panel.title' }],
  // Comments are search documents of their own (entity type `comment`); posts use the search module's default item.
  searchRenderers: { comment: PostCommentSearchResult },
  groupTabs: [
    {
      id: 'feed',
      labelKey: 'feed:groupTab.title',
      order: 10,
      element: (groupId) => createElement(LazyGroupFeedTab, { groupId }),
    },
  ],
  setup: ({ queryClient, realtime }) => {
    registerFeedRealtime(queryClient, realtime);
  },
});
